import { AxiosResponse } from 'axios';

export const VIRTUAL_SORT_OPTIONS = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

export type VirtualSortTypes = 'asc' | 'desc';

export type VirtualSearchCallback<T> = (
  payload: VirtualSearchPayload<T>
) => Promise<AxiosResponse<VirtualSearchResponse<T>>>;

export interface VirtualSortType {
  name: string;
  order: VirtualSortTypes;
}

export type VirtualFormModel = Record<string, unknown> & Pick<VirtualSearchPayload, 'sortBy'>;

export type VirtualSearchAfter = [number, number];

type VirtualSearchFilters<T = Record<string, unknown>> = Partial<
  Record<keyof T | `${keyof T & string}.keyword`, string | string[] | boolean>
>;

export type VirtualSearchPayload<T = Record<string, unknown>> = VirtualSearchFilters<T> & {
  chunkSize: number;
  pit?: string;
  searchAfter?: VirtualSearchAfter;
  sortBy?: VirtualSortType;
};

export interface VirtualSearchResponse<T = Record<string, unknown>> {
  count: number;
  total: number;
  pit: string;
  items: VirtualSearchResponseItem<T>[];
  aggregations: {
    [key in keyof Partial<T> as AggregationKey<T, key>]: VirtualSearchResponseAggregation;
  };
}

export interface VirtualSearchResponseItem<T> {
  _index: string;
  _type: string;
  _id: string;
  _score: unknown;
  _source: T;
  sort: VirtualSearchAfter;
}

export type VirtualSearchResponseAggregation = {
  doc_count_error_upper_bound: number;
  sum_other_doc_count: number;
  buckets: VirtualSearchResponseBucket[];
};

export type AggregationStringKeyword<key extends string> = `${key}.keyword`;

export type AggregationObjectKeyword<key extends string> =
  | AggregationStringKeyword<key>
  | AggregationStringKeyword<`${key}.accountName`>
  | AggregationStringKeyword<`${key}.description`>;

export type AggregationKey<T, key extends keyof T> = T[key] extends boolean
  ? key
  : T[key] extends object
  ? AggregationObjectKeyword<key & string>
  : T[key] extends string | Date
  ? AggregationStringKeyword<key & string> | key
  : never;

export interface VirtualSearchResponseBucket {
  key: string | number;
  key_as_string?: string;
  doc_count: number;
}
